import React, { useState, useEffect } from 'react';
import styles from './Movies.module.scss';

const LIMIT = 8;

const Movies = (props) => {
  const { 
    movies,
    homeURL,
    selectedFilters,
    isComingSoon,
    showAllMovies,
    concessionEnabledParam,
    testCinemasEnabled
  } = props

  const [showMore, setShowMore] = useState(true);
  const [list, setList] = useState([]);
  const [index, setIndex] = useState(LIMIT);

  // load first page movies
  useEffect(() => {
    const shouldShowMore = movies.length > LIMIT && !Number(showAllMovies);

    if (shouldShowMore) {
      setList(movies.slice(0, LIMIT));
      setIndex(LIMIT);
    } else {
      setList(movies);
    }
    
    setShowMore(shouldShowMore);
  }, [movies]);

  const loadMore = () =>{
    const newIndex = index + LIMIT;
    const newShowMore = newIndex < (movies.length - 1);
    const newList = list.concat(movies.slice(index, newIndex));
    setIndex(newIndex);
    setList(newList);
    setShowMore(newShowMore);
  }

  let isAnyFilterSelected = 0;

  Object.keys(selectedFilters).forEach(filter => {
    if (isAnyFilterSelected === 0 && selectedFilters[filter].length > 0) {
      isAnyFilterSelected = 1;
    }
  });

  const noSearchResultsFound = list.length === 0 && isAnyFilterSelected;
  const globalData = window.rpReactPlugin || {};
  return (
    <div className="browser-content">
      <div className={styles.movies}>
        {
          list.map((movie, index) => {
            try {
              const movieMeta = [ movie.ratingName, movie.length + ' ' + window.mapiTranslations['Minutes'], movie.attrs.filter(item => item).join(' / ') ];
              const siteIdInput = document.querySelector('input[name="single_cinema_id"]'); // for single "mb_cinema" pages
              let imageSrc = 'https://www.yesplanet.co.il/xmedia-cw/repo/feats/posters/' + movie.code + '-lg.jpg';
              let imageSrcMobile =  'https://www.yesplanet.co.il/xmedia-cw/repo/feats/posters/' + movie.code + '-md.jpg';
              let movieURL = homeURL + 'movie/' + movie.slug + '/';

              // if there is assets dir (Hocode) set use new URL structure
              if ( globalData.assets_dir ) {
                imageSrc = globalData.assets_bucket_url + '/HO-' + globalData.assets_dir + '/eventmaster/' + movie.emid + '_4.png';
                imageSrcMobile =  globalData.assets_bucket_url + '/HO-' + globalData.assets_dir + '/eventmaster/' + movie.emid + '_4.png';
              }

              if (siteIdInput) {
                movieURL += '?cinema=' + siteIdInput.value;
              } else if (selectedFilters.cinema && selectedFilters.cinema.length) {
                movieURL += '?cinema=' + selectedFilters.cinema[0];
              }

              if (concessionEnabledParam) {
                if (movieURL.indexOf('?') === -1) {
                  movieURL += '?concessionEnabled=' + concessionEnabledParam;
                } else {
                  movieURL += '&concessionEnabled=' + concessionEnabledParam;
                }
              }

              if (testCinemasEnabled) {
                if (movieURL.indexOf('?') === -1) {
                  movieURL += '?isTest=' + testCinemasEnabled;
                } else {
                  movieURL += '&isTest=' + testCinemasEnabled;
                }
              }

              // poster label
              let labelStyleClass = '';
              let labelText = '';
              if (movie.isPreSale) {
                labelStyleClass = 'preSale';
                labelText = window.mapiTranslations['Pre-sale'];
              } else if (movie.isPremiere) {
                labelStyleClass = 'premiere';
                labelText = window.mapiTranslations['Premiere'];
              } else if (movie.attrsList.includes('FINV')) {
                labelStyleClass = 'inclusive';
                labelText = window.mapiTranslations['Inclusive'];
              }

              return (
                <div key={movie.code || index} className={styles.movie + ' item-movie'}>
                  <a href={movieURL}>
                    <picture>
                      <img src={imageSrc} class="d-block w-100" alt="" onError={(e)=>{e.target.onerror = null; e.target.src="https://cinepolis.com.hn/wp-content/themes/cinema-world/resources/images/poster-not-found.jpg"}} />
                      {labelText && <span className={styles.label + ' ' + styles[labelStyleClass]}>{labelText}</span>}
                    </picture>

                    <div className={styles.movieContent}>
                      <h3>{movie.webName}</h3>

                      <div className={styles.movieMeta}>
                        {movieMeta.filter(item => item).join(' | ')}
                      </div>
                    </div>
                  </a>
                </div>
              );
            } catch (err) {
              console.error('Error rendering movie', movie, err);
              return null; // skip rendering this item
            }
          })
        }

        {noSearchResultsFound === 1 &&
          <div className={styles.noResultsMessageWrapper}>
            <span cl></span>
            {window.mapiTranslations['There are no showtimes available for the selected criteria. Please change your search criteria, or check again later.']}
          </div>
        }

        {isComingSoon && list.length === 0 &&
          <div className={styles.noResultsMessageWrapper}>
            <span cl></span>
            {window.mapiTranslations['There are no showtimes available for the selected criteria. Please change your search criteria, or check again later.']}
          </div>
        }
      </div>

      {showMore && <button className="button button-primary" onClick={loadMore}>{window.mapiTranslations['Show More']}</button>}
    </div>
  );
}

export { Movies };
